export const getLinkedDocuments = (result, completeData) => {
  return result.linkedDocuments.map(x => ({
    dbId: completeData[x.instanceId],
    instanceId: x.instanceId,
  }))
}
